import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.scss';

const Skeleton = ({ fadeOut, styleForTemplate, withTemplate }) => {
    const classes = classNames({
        [styles.skeleton]: true,
        [styles.fadeOut]: fadeOut,
    });
    if (withTemplate) {
        return (
            <div style={styleForTemplate} className={styles.template}>
                <div className={classes} />
            </div>
        );
    }
    return <div className={classes} />;
};
export default Skeleton;
Skeleton.propTypes = {
    withTemplate: PropTypes.bool,
    styleForTemplate: PropTypes.object,
    fadeOut: PropTypes.bool,
};
